import ConversationPipelineAPI from '../../api/conversationPipeline';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getProcesses(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await ConversationPipelineAPI.get();
      commit('SET_PROCESSES', response.data.payload);
      return response.data.payload;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, data) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await ConversationPipelineAPI.createProcess(data);
      commit('UPSERT_PROCESS', response.data.payload);
      return response.data.payload;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async update({ commit }, { id, ...data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await ConversationPipelineAPI.updateProcess(id, data);
      commit('UPSERT_PROCESS', response.data.payload);
      return response.data.payload;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async createStage({ commit }, { processId, ...data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await ConversationPipelineAPI.createStage(
        processId,
        data
      );
      commit('UPSERT_PROCESS', response.data.payload);
      return response.data.payload;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async updateStage({ commit }, { processId, id, ...data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await ConversationPipelineAPI.updateStage(
        processId,
        id,
        data
      );
      commit('UPSERT_PROCESS', response.data.payload);
      return response.data.payload;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async deleteStage({ commit }, { processId, id }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await ConversationPipelineAPI.deleteStage(processId, id);
      commit('UPSERT_PROCESS', response.data.payload);
      return response.data.payload;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async reorderStages({ commit }, { processId, stageIds }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await ConversationPipelineAPI.reorderStages(
        processId,
        stageIds
      );
      commit('UPSERT_PROCESS', response.data.payload);
      return response.data.payload;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
};

export const mutations = {
  SET_PROCESSES(_state, processes) {
    _state.records = processes;
  },
  UPSERT_PROCESS(_state, process) {
    const index = _state.records.findIndex(record => record.id === process.id);
    if (index === -1) {
      _state.records = [..._state.records, process];
      return;
    }

    _state.records = _state.records.map(record =>
      record.id === process.id ? process : record
    );
  },
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
